export default __webpack_public_path__ + "static/badge-enter-extended-80b9c7107dfc3fad4e086f683240018b.webp";